import { createAsyncThunk } from '@reduxjs/toolkit';
import services from '../services';

export const updateTask = createAsyncThunk(
    'task/updateTask',
    async ({ newDate, type, taskItem }, { rejectWithValue }) => {
        try {
            const data = {
                reminder: type === 'reminder' ? newDate : null,
                myDayPlan: type === 'myDayPlan' ? newDate : null,
                nextStep: type === 'nextStep' ? newDate : null,
                deadline: type === 'deadline' ? newDate : null,
                notes: '',
                gmailMessageId: taskItem?.gmailMessageId,
                contactId: taskItem?.contactId,
            };
            await services.task.UPDATE_TASK_GMAIL_WHATSAAP(taskItem, data);
            return true;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const getTaskMail = createAsyncThunk('task/GET_TASK', async (_, { rejectWithValue }) => {
    try {
        const query = {
            limit: 400,
        };
        const obj = new URLSearchParams(query);
        const response = await services.task.GET_TASK(obj);
        return response?.data || [];
    } catch (error) {
        console.error(error, 'error')
        return rejectWithValue(error.message);
    }
});

export const getAllDateTableTask = createAsyncThunk(
    'task/getAllDateTableTask',
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await services.task.GET_ALL_TASK(data?.boardId);
            return response?.data || [];
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const getAllBoardDateTable = createAsyncThunk('task/getAllBoardDateTable', async (_, { rejectWithValue }) => {
    try {
        const response = await services.board.GET_ALL_BOARD_DATE_TABLE();
        return response?.data || [];
    } catch (error) {
        return rejectWithValue(error.message);
    }
});
